import { render, staticRenderFns } from "./BaseCheckBox.vue?vue&type=template&id=729368d2&"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js&"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports